import React, { Component } from "react";
import logo from "../logo.png";
import { Link } from "react-router-dom";

/* creating a header component for trip home component  */

export class TripHeaderComponent extends Component {
  render() {
    return (
      <>
        <header className="header">
          <nav className="navbar navbar-dark navbar-expand-md bg-dark sticky-top">
            <div className="container">
              <Link to="/" className="navbar-brand">
                <img
                  src={logo}
                  alt="logo"
                  style={{ height: 50, width: 50 }}
                  className="d-inline-block me-2 ms-1"
                />
                <span className="text-white h2 fw-bolder align-middle">
                  Kaali
                </span>
                <span
                  className=" h2  fw-bolder align-middle"
                  style={{ color: "#ffeb3b" }}
                >
                  Peeli
                </span>
              </Link>
            </div>
          </nav>
        </header>
      </>
    );
  }
}

//exporting the TripHeaderComponent
export default TripHeaderComponent;
